import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Fallback UI для React.lazy при загрузке chunk'а. Показывается максимум
 * 100-300 мс — при первом переходе на страницу, пока браузер качает JS.
 * Повторные переходы отдают из кэша без фолбэка.
 */
export function RouteLoading() {
    return (_jsx("div", { className: "flex items-center justify-center min-h-[40vh]", children: _jsx("div", { className: "h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin", role: "status", "aria-label": "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430" }) }));
}
